import React, { useEffect, useState } from "react";
import {
  ShareurlWithImg,
  Toast,
  Userlogin,
  formatRupee,
  handleGetApiGF,
  handlePostApiGF,
} from "../Utils/general-function";
import { useNavigate, Link, useParams } from "react-router-dom";
import Header from "../Header";
import Loader from "../Utils/Loader";
import RemainingPageTitle from "../Utils/RemainingPageTitle";
import NoCars from "../Utils/NoCars";
import ScrollButton from "../Utils/scrollbutton";
import { FiShare2 } from "react-icons/fi";

import blackheart from "../../src_img/blackheart.png";
import redheart from "../../src_img/redheart.png";

// THIS WISHLIST CAR PAGE IS SHARABLE SHOW HERE LIST BE BASED ON DEALER RAND NUMBER

function CustomerCarWishlists() {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [allFavCars, setAllFavCars] = useState([]);
  const [loggedInUserFavCars, setLoggedInUserFavCars] = useState(new Set());
  const { dealerrand } = useParams() || {}; // wishlist of car of dealer which may own or other dealer
  let loggedInUserRand = localStorage.getItem("Ca1itd");
  let isOwner = dealerrand && dealerrand === loggedInUserRand; // this will check if the user is accessing their own wishlist or someone else's

  const fetchAllFavCarsList = async () => {
    const [carList, loggedInUserFavList] = await Promise.all([
      handleGetApiGF({
        url:
          "/api/DealerFavouriteVehicle/AllFavouritecars?dealerrandno=" +
          dealerrand,
      }), // this is for car list
      handleGetApiGF({
        url:
          "/api/DealerFavouriteVehicle/AllFavouritecars?dealerrandno=" +
          loggedInUserRand,
      }), // this is to check car is wishlisted or not
    ]);
    if (!carList?.succ || !loggedInUserFavList?.succ) {
      Toast(false, "", carList?.msg || "Something went wrong!");
      setLoading(false);
      return;
    }
    setAllFavCars(carList?.data?.Data || []);
    let loggedInUserFavCarsIds = (loggedInUserFavList?.data?.Data || []).map(
      (item) => item?.carid,
    );
    setLoggedInUserFavCars(new Set(loggedInUserFavCarsIds)); // to check wishlisted or not
    setLoading(false);
  };

  const addRemoveWishlist = async (details) => {
    setLoading(true);
    const { carnumber, carid } = details || {};
    if (!carnumber || !carid) return;

    let obj = {
      actiondata: loggedInUserFavCars?.has(carid) ? "Delete" : "Add",
      carnumber,
      carid,
    };
    const res = await handlePostApiGF({
      url: "/api/DealerFavouriteVehicle/addfavouritecars",
      obj,
    });
    setLoading(false);
    Toast(
      res?.succ,
      res?.msg || "Successful",
      res?.msg || "Something went wrong",
    );
    await fetchAllFavCarsList();
  };
  useEffect(() => {
    fetchAllFavCarsList();
  }, []);

  return (
    <div>
      <Header />
      {allFavCars?.length > 0 ? (
        <div className="text-center d-flex align-items-center justify-content-between page-space">
          <h2 className="page-title mb-0 p-0 text-center">
            {isOwner ? "My" : "Shared"} Wishlist
          </h2>
          <div
            className="d-flex align-items-center gap-2 justify-content-center"
            style={{
              border: "1px solid red",
              borderRadius: "6px",
              padding: "5px 5px",
              color: "red",
              fontWeight: "500",
              fontSize: "16px",
            }}
            onClick={(e) => {
              let url = new URL(
                `/#/customercarwishlists/${dealerrand}`,
                window.location.origin,
              ).href;
              ShareurlWithImg({
                url,
              });
            }}
          >
            <FiShare2 size={20} /> Share All
          </div>
        </div>
      ) : (
        <div className="text-center d-flex align-items-center justify-content-center page-space">
          <h2 className="page-title mb-0 p-0 text-center">Wishlisted Car</h2>
        </div>
      )}

      <div className="page-space pt-0" style={{ marginBottom: "50px" }}>
        {loading && <Loader />}
        {allFavCars.length === 0 && !loading ? (
          <>
            <NoCars
              mainMsg=""
              msg="Your wishlist is empty. Start adding your favorite cars!"
            />
            <div className="w-100 text-center">
              <Link to={"/customercarlist"} className="submitbtn">
                See All Cars
              </Link>
            </div>
          </>
        ) : (
          allFavCars.map((data, i) => (
            <div className="car-div mt-4" key={data.Rand}>
              <div className="car-radius">
                <div className="position-relative">
                  <img
                    src={
                      loggedInUserFavCars.has(data.carid)
                        ? redheart
                        : blackheart
                    }
                    style={{
                      position: "absolute",
                      right: "10px",
                      top: "10px",
                    }}
                    alt=""
                    onClick={() => addRemoveWishlist(data)}
                  />

                  <div
                    style={{
                      position: "absolute",
                      right: "11px",
                      top: "50px",
                      backgroundColor: "aliceblue",
                      padding: "4px",
                      borderRadius: "100%",
                      color: "red",
                      height: "30px",
                      width: "30px",
                    }}
                  >
                    <FiShare2
                      size={20}
                      style={{ position: "relative", top: "-2px" }}
                      onClick={(e) => {
                        let url = new URL(
                          `/#/customercardetail/${data?.Rand}?rand=${dealerrand}`,
                          window.location.origin,
                        ).href;
                        ShareurlWithImg({
                          url,
                          text: `${data?.modelyear} ${data?.companyid} ${data?.carmodelid} ${data?.variantid}`,
                        });
                      }}
                    />
                  </div>
                  <img src={data.carphoto} className="w-100" alt="" />
                </div>
                <div className="car-smdetails">
                  <span className="abs-span">{data.fueltypeid}</span>
                  <RemainingPageTitle dataFromParent={data} />

                  <div className="car-km justify-content-start gap-2 flex-wrap">
                    <>
                      <div className="d-flex align-items-center">
                        <img src="assets/images/car-num.svg" alt="" />
                        <span>{data.carnumber}</span>
                      </div>
                      {data.km && (
                        <div className="d-flex align-items-center">
                          <img
                            src="assets/images/car-km.svg"
                            alt=""
                            // className="ms-2"
                          />
                          <span>
                            {formatRupee({ amt: data.km, rupeeIcon: false })}
                          </span>
                        </div>
                      )}

                      {data?.clientprofilelist[0]?.nCity && (
                        <div className="d-flex align-items-center">
                          <img
                            src="assets/images/address.png"
                            height={21}
                            width={21}
                            alt="address"
                          />
                          <span>
                            {data?.clientprofilelist[0]?.nCity},{" "}
                            {data?.clientprofilelist[0]?.nState}
                          </span>
                        </div>
                      )}
                    </>
                  </div>
                </div>
                <div className="two-btns">
                  <Link
                    to={`/customercardetail/${data?.Rand}`}
                    state={{ details: data }}
                    className="w-100 lightRedBtn"
                    style={{ borderRadius: "0 0 10px 10px" }}
                  >
                    More Details
                  </Link>
                </div>
              </div>
            </div>
          ))
        )}
        <ScrollButton />
      </div>
    </div>
  );
}

export default CustomerCarWishlists;

// both are updated
// import React, { useEffect, useState } from "react";
// import {
//   ShareurlWithImg,
//   Toast,
//   Userlogin,
//   formatRupee,
//   handleGetApiGF,
//   handlePostApiGF,
// } from "../Utils/general-function";
// import { useNavigate, Link, useParams } from "react-router-dom";
// import Header from "../Header";
// import Loader from "../Utils/Loader";
// import RemainingPageTitle from "../Utils/RemainingPageTitle";
// import NoCars from "../Utils/NoCars";
// import ScrollButton from "../Utils/scrollbutton";
// import { FiShare2 } from "react-icons/fi";
// // advance filter

// import blackheart from "../../src_img/blackheart.png";
// import redheart from "../../src_img/redheart.png";

// // THIS WISHLIST CAR PAGE IS SHARABLE SHOW HERE LIST BE BASED ON DEALER RAND NUMBER

// function CustomerCarWishlists() {
//   const navigate = useNavigate();
//   const [loading, setLoading] = useState(true);
//   const [allFavCars, setAllFavCars] = useState([]);
//   const [loggedInUserFavCars, setLoggedInUserFavCars] = useState(new Set());
//   const { dealerrand } = useParams() || {}; // wishlist of car of dealer which may own or other dealer
//   let loggedInUserRand = localStorage.getItem("Ca1itd");
//   let isOwner = dealerrand && dealerrand === loggedInUserRand; // this will check if the user is accessing their own wishlist or someone else's
//   const fetchAllFavCarsList = async () => {
//     const [carList, loggedInUserFavList] = await Promise.all([
//       handleGetApiGF({
//         url:
//           "/api/DealerFavouriteVehicle/AllFavouritecars?dealerrandno=" +
//           dealerrand,
//       }), // this is for car list
//       handleGetApiGF({
//         url:
//           "/api/DealerFavouriteVehicle/AllFavouritecars?dealerrandno=" +
//           loggedInUserRand,
//       }), // this is to check car is wishlisted or not
//     ]);
//     if (!carList?.succ || !loggedInUserFavList?.succ) {
//       Toast(false, "", carList?.msg || "Something went wrong!");
//       setLoading(false);
//       return;
//     }
//     setAllFavCars(carList?.data?.Data || []);
//     let loggedInUserFavCarsIds = (loggedInUserFavList?.data?.Data || []).map(
//       (item) => item?.carid,
//     );
//     setLoggedInUserFavCars(new Set(loggedInUserFavCarsIds));
//     setLoading(false);
//   };

//   const addRemoveWishlist = async (details) => {
//     setLoading(true);
//     const { carnumber, carid } = details || {};
//     if (!carnumber || !carid) return;

//     let obj = {
//       actiondata: loggedInUserFavCars?.has(carid) ? "Delete" : "Add",
//       carnumber,
//       carid,
//     };
//     const res = await handlePostApiGF({
//       url: "/api/DealerFavouriteVehicle/addfavouritecars",
//       obj,
//     });
//     setLoading(false);
//     Toast(
//       res?.succ,
//       res?.msg || "Successful",
//       res?.msg || "Something went wrong",
//     );
//     await fetchAllFavCarsList();
//   };
//   useEffect(() => {
//     fetchAllFavCarsList();
//   }, []);

//   return (
//     <div>
//       <Header />
//       {allFavCars?.length > 0 ? (
//         <div className="text-center d-flex align-items-center justify-content-between page-space">
//           <h2 className="page-title mb-0 p-0 text-center  fs-5">
//             {!isOwner && "Other's "} Wishlisted Car
//           </h2>
//           <div
//             className="d-flex align-items-center gap-2 justify-content-center"
//             style={{
//               border: "1px solid red",
//               borderRadius: "6px",
//               padding: "5px 5px",
//               color: "red",
//               fontWeight: "500",
//               fontSize: "16px",
//             }}
//             onClick={(e) => {
//               let url = new URL(
//                 `/#/customercarwishlists/${dealerrand}`,
//                 window.location.origin,
//               ).href;
//               ShareurlWithImg({
//                 url,
//               });
//             }}
//           >
//             <FiShare2 size={20} /> Share All
//           </div>
//         </div>
//       ) : (
//         <div className="text-center d-flex align-items-center justify-content-center page-space">
//           <h2 className="page-title mb-0 p-0 text-center">Wishlisted Car</h2>
//         </div>
//       )}

//       <div className="page-space pt-0" style={{ marginBottom: "50px" }}>
//         {loading && <Loader />}
//         {allFavCars.length === 0 && !loading ? (
//           <>
//             <NoCars
//               mainMsg=""
//               msg="Your wishlist is empty. Start adding your favorite cars!"
//             />
//             <div className="w-100 text-center">
//               <Link to={"/customercarlist"} className="submitbtn">
//                 See All Cars
//               </Link>
//             </div>
//           </>
//         ) : (
//           allFavCars.map((data, i) => (
//             <div className="car-div mt-4" key={data.Rand}>
//               <div className="car-radius">
//                 <div className="position-relative">
//                   <img
//                     src={
//                       loggedInUserFavCars.has(data.carid)
//                         ? redheart
//                         : blackheart
//                     }
//                     style={{
//                       position: "absolute",
//                       right: "10px",
//                       top: "10px",
//                     }}
//                     alt=""
//                     onClick={() => addRemoveWishlist(data)}
//                   />

//                   <div
//                     style={{
//                       position: "absolute",
//                       right: "11px",
//                       top: "50px",
//                       backgroundColor: "aliceblue",
//                       padding: "4px",
//                       borderRadius: "100%",
//                       color: "red",
//                       height: "30px",
//                       width: "30px",
//                     }}
//                   >
//                     <FiShare2
//                       size={20}
//                       style={{ position: "relative", top: "-2px" }}
//                       onClick={(e) => {
//                         let url = new URL(
//                           `/#/customercardetail/${data?.Rand}?rand=${dealerrand}`,
//                           window.location.origin,
//                         ).href;
//                         ShareurlWithImg({
//                           url,
//                           text: `${data?.modelyear} ${data?.companyid} ${data?.carmodelid} ${data?.variantid}`,
//                         });
//                       }}
//                     />
//                   </div>
//                   <img src={data.carphoto} className="w-100" alt="" />
//                 </div>
//                 <div className="car-smdetails">
//                   <span className="abs-span">{data.fueltypeid}</span>
//                   <RemainingPageTitle dataFromParent={data} />

//                   <div className="car-km justify-content-start gap-2 flex-wrap">
//                     <>
//                       <div className="d-flex align-items-center">
//                         <img src="assets/images/car-num.svg" alt="" />
//                         <span>{data.carnumber}</span>
//                       </div>
//                       {data.km && (
//                         <div className="d-flex align-items-center">
//                           <img
//                             src="assets/images/car-km.svg"
//                             alt=""
//                             // className="ms-2"
//                           />
//                           <span>
//                             {formatRupee({ amt: data.km, rupeeIcon: false })}
//                           </span>
//                         </div>
//                       )}

//                       {data?.clientprofilelist[0]?.nCity && (
//                         <div className="d-flex align-items-center">
//                           <img
//                             src="assets/images/address.png"
//                             height={21}
//                             width={21}
//                             alt="address"
//                           />
//                           <span>
//                             {data?.clientprofilelist[0]?.nCity},{" "}
//                             {data?.clientprofilelist[0]?.nState}
//                           </span>
//                         </div>
//                       )}
//                     </>
//                   </div>
//                 </div>
//                 <div className="two-btns">
//                   <Link
//                     to={`/customercardetail/${data?.Rand}`}
//                     state={{ details: data }}
//                     className="w-100 lightRedBtn"
//                     style={{ borderRadius: "0 0 10px 10px" }}
//                   >
//                     More Details
//                   </Link>
//                 </div>
//               </div>
//             </div>
//           ))
//         )}
//         <ScrollButton />
//       </div>
//     </div>
//   );
// }

// export default CustomerCarWishlists;
